import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { InlineExternalImageParams } from './InlineExternalImage.ts';

export const InlineExternalImage: LoadableType<InlineExternalImageParams> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InlineExternalImage" */ '../src/InlineExternalImage.tsx'
			)
		).InlineExternalImage,
});

export type { InlineExternalImageParams } from '../src/InlineExternalImage.tsx';
